import {Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';
import {activeLanguageKey} from './config/language.config';
import {TokenService} from './shared/token.service';
import {COOKIE_CONSENT, getCookie} from './config/cookies.config';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {SignalRLogoutService} from './services/signalr-logout.service';

const defaultLanguage = 'pl';
declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'kns-core';
  private googleAnalytics: boolean = false;

  constructor(oauthService: OAuthService, translate: TranslateService, tokenService: TokenService,
              private router: Router,
              private signalRLogoutService: SignalRLogoutService) {
    tokenService.logoutOnTokenExpired();

    if (environment.enableSignalR) {
      if (oauthService.hasValidAccessToken()) {
        this.signalRLogoutService.start();
      }
      oauthService.events
        .pipe(filter((e: any) => e.type === 'token_received'))
        .subscribe(() => {
          this.signalRLogoutService.start();
        });
    }

    translate.setDefaultLang(defaultLanguage);
    const languageName = localStorage.getItem(activeLanguageKey);

    if (languageName) {
      translate.use(languageName);
    } else {
      translate.use(environment.language);
    }

  }

  ngOnInit(): void {
    const cookieConsent = getCookie(COOKIE_CONSENT);
    if (!cookieConsent) {
      window[`ga-disable-${environment.ga}`] = true;
      return;
    }

    const cookieConsentValues = cookieConsent.split('|');
    this.googleAnalytics = cookieConsentValues[0] === '1';
    window[`ga-disable-${environment.ga}`] = !this.googleAnalytics || !environment.production;
    if (this.googleAnalytics && environment.production) {
      this.setUpAnalytics();
    }
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
          gtag('config', environment.ga,
            {
              page_path: event.urlAfterRedirects
            }
          );
      });
  }

}
